// extracted by mini-css-extract-plugin
module.exports = {"form":"Login_form__V3l1k","header":"Login_header__3r3Xa","logo":"Login_logo__30kj8","wrap":"Login_wrap__39ndS"};